import React, { useState, useEffect } from "react";
import axios from "axios";
// Import Link and useNavigate from react-router-dom
import { Link, useNavigate } from "react-router-dom";
// Import the authentication check function
import { isAuthenticated } from "utils/auth"; // Make sure the path is correct
import IndexFooter from "components/Footers/IndexFooter.js";

// reactstrap components
import {
  Button,
  Card,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Container,
  Row,
  Col,
  Alert,
  Spinner
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";

// API endpoint for registration
const API_URL = "https://api.pembrokefarmersmarket.ca/api/vendors/register"; // Adjust if needed

function RegisterPage() {
  const [formData, setFormData] = useState({ name: "", email: "", password: "" });
  const [feedback, setFeedback] = useState({ message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Use the navigate hook for redirection
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user is already logged in
    if (isAuthenticated()) {
      // If logged in, redirect to the ProfilePage
      navigate("/profile-page"); //
    } else {
      // Only add class and scroll if not redirecting
      document.body.classList.add("register-page");
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
    }

    // Cleanup function to remove the class when the component unmounts
    return function cleanup() {
      document.body.classList.remove("register-page");
    };
    // Add navigate to the dependency array as it's used in the effect
  }, [navigate]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFeedback({ message: '', type: '' });

    try {
      await axios.post(API_URL, formData);
      setFeedback({ message: "✅ Registration successful! You can now log in.", type: "success" });
      // Optionally clear form:
      // setFormData({ name: "", email: "", password: "" });
      // Note: No redirect here after registration, user should go to login page
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Registration failed. Please check your details and try again.";
      setFeedback({ message: `❌ ${errorMessage}`, type: "danger" });
      console.error("Registration error:", err.response || err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <IndexNavbar />
      <div
        className="page-header"
        style={{
          backgroundImage: "url(" + require("assets/img/login-image.jpg") + ")",
        }}
      >
        <div className="filter" />
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" lg="4">
              <Card className="card-register ml-auto mr-auto">
                <h3 className="title mx-auto">Become a Vendor</h3>

                <Form className="register-form" onSubmit={handleSubmit}>
                  {/* Display Feedback */}
                  {feedback.message && (
                    <Alert color={feedback.type} isOpen={!!feedback.message} toggle={() => setFeedback({ message: '', type: '' })} style={{fontSize: '0.85rem', padding: '0.5rem 1rem'}}>
                      {feedback.message}
                    </Alert>
                  )}

                  <FormGroup>
                    <Label for="registerName">Full Name</Label>
                    <InputGroup>
                       <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                             <i className="nc-icon nc-single-02" />
                          </InputGroupText>
                       </InputGroupAddon>
                        <Input
                          id="registerName"
                          name="name"
                          placeholder="Name"
                          type="text"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                        />
                     </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <Label for="registerEmail">Email</Label>
                     <InputGroup>
                       <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                             <i className="nc-icon nc-email-85" />
                          </InputGroupText>
                       </InputGroupAddon>
                        <Input
                          id="registerEmail"
                          name="email"
                          placeholder="Email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                        />
                     </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <Label for="registerPassword">Password</Label>
                     <InputGroup>
                       <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                             <i className="nc-icon nc-key-25" />
                          </InputGroupText>
                       </InputGroupAddon>
                        <Input
                          id="registerPassword"
                          name="password"
                          placeholder="Password"
                          type="password"
                          value={formData.password}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                        />
                     </InputGroup>
                  </FormGroup>

                  <Button block className="btn-round" color="danger" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? <><Spinner size="sm" /> Registering...</> : 'Register'}
                  </Button>
                </Form>
                {/* Link to Login Page */}
                <div className="text-center mt-3"> {/* Added text-center and margin */}
                  <p style={{ color: '#dcedcd', fontSize: '0.9rem' }}> {/* Adjusted styling */}
                    Already a vendor?{" "}
                    <Link to="/login" style={{ color: 'white', fontWeight: 'bold' }}>
                      Login here
                    </Link>
                  </p>
                </div>
                 {/* Removed Forgot Password link */}
                 {/* <div className="forgot"> ... </div> */}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>      
      {/* Use the new IndexFooter component */}
      <IndexFooter />
    </>
  );
}

export default RegisterPage;